import { ReturnType } from "../return";
import * as languageResource from "./language";

// Naming: project_element_description
// A word on translation key naming conventions https://tolgee.io/blog/naming-translation-keys
export interface Resource {
  DOCUMENT_TITLE: string;
  TYPE_DISPLAY_NAME: string;
  ORDERLESS_DISPLAY_NAME: string;
  LOGIN_FIELD_ONE_LABEL: string;
  LOGIN_FIELD_TWO_LABEL: string;
  PORTAL_BUTTON_TEXT: string;
  PORTAL_GIFT_BUTTON_TEXT: string;
  PORTAL_POLICY_LINK_TEXT: string;
  PORTAL_WARRANTY_LINK_TEXT: string;
  ITEMS_BEING_RETURNED_SECTION_HEADER: string;
  ITEMS_DISCLAIMER: string;
  NEW_ITEMS_SECTION_HEADER: string;
  IN_STORE_RETURN_TEXT: string;
  IN_STORE_RETURN_SUBTEXT: string;
  THIRD_PARTY_ITEMS_HEADER: string;
  THIRD_PARTY_ITEMS_SUBHEADER: string;
  THIRD_PARTY_DOCUMENT_TITLE: string;
  THIRD_PARTY_HEADER: string;
  FEES_HEADER: string;
  FEES_ORDER_HEADER: string;
  RETURN_ITEMS_HEADER: string;
  FREE_SHIPPING_LABEL_TEXT_NO_BRANDING: string;
  FREE_SHIPPING_LABEL_TEXT: string;
  REVIEW_SUBMIT_BUTTON_TEXT: string;
  REVIEW_SHIPPING_FROM_TEXT: string;
  REVIEW_LABEL_COVERAGE: string;
  REVIEW_SHIPPING_TO_SAME_TEXT: string;
  REVIEW_FLOW_HEADER: string;
  STATUS_STEPS_TITLE: string;
  STATUS_MANUAL_REVIEW_TITLE: string;
  STATUS_MANUAL_REVIEW_SUBTITLE: string;
  STATUS_IN_TRANSIT_TITLE: string;
  STATUS_IN_TRANSIT_SUBTITLE: string;
  STATUS_IN_TRANSIT_QR_CODE: string;
  STATUS_IN_TRANSIT_QR_CODE_ONLY: string;
  STATUS_IN_TRANSIT_MULTI_SHIPMENT_SUBTITLE: string;
  STATUS_PROCESSED_TITLE: string;
  STATUS_PROCESSED_SUBTITLE: string;
  STATUS_PROCESSED_REPAIR_TITLE: string;
  STATUS_PROCESSED_REPAIR_SUBTITLE: string;
  STATUS_SHIPPING_TEXT: string;
  STATUS_DROP_OFF_SUBTITLE: string;
  EMAIL_SUBJECT: string;
  EMAIL_HEADING: string;
  EMAIL_BODY: string;
  EMAIL_SHIPMENT_LABEL: string;
  EMAIL_SHIPMENT_TITLE: string;
  EMAIL_SHIPMENT_URL: string;
  EMAIL_STEP_1: string;
  EMAIL_REVIEW_SUBJECT: string;
  EMAIL_REVIEW_BODY_1: string;
  EMAIL_CREATED_SUBJECT: string;
  EMAIL_CREATED_HEADING: string;
  EMAIL_CREATED_BODY_1: string;
  GIFT_RECEIPT_EMAIL_SUBJECT: string;
  GIFT_RECEIPT_EMAIL_HEADER: string;
  GIFT_RECEIPT_EMAIL_BODY: string;
  GIFT_RECEIPT_EMAIL_LINK_TEXT: string;
  IN_STORE_RETURN_EMAIL_STEP_1: string;
  IN_STORE_RETURN_EMAIL_STEP_2: string;
  INSTANT_EXCHANGE_DISCLAIMER_SUBTEXT: string;
  SHOPIFY_NOTE: string;
  REVIEW_HEADER_TEXT: string;
  CHOOSE_ITEMS_TEXT: string;
  CHOOSE_VARIANT_TEXT: string;
  PENDING_ITEM_PILL_TEXT: string;
  CONFIRMATION_HEADER_TEXT_SUBMIT: string;
  CONFIRMATION_HEADER_SUBTEXT: string;
  CONFIRMATION_HEADER_TEXT_SUBMIT_WITH_ERRORS: string;
  CONFIRMATION_HEADER_TEXT_REJECT: string;
  DRAFT_ORDER_HEADER: string;
  DRAFT_ORDER_SUBTITLE: string;
  DROP_OFF_PACKAGE_TEXT: string;
  DROP_OFF_PACKAGE_SUBTEXT: string;
  GREEN_RETURN_PROCESS_STEP_TEXT: string;
  PORTAL_ORDERS_TABLE_RETURNS_HEADER: string;
  PORTAL_ORDER_TABLE_RETURN_LINK_TEXT: string;
  PICKUP_MODAL_MAIN_TEXT: string;
  PICKUP_MODAL_SUB_TEXT: string;
  PICKUP_MODAL_PICKUP_BUTTON_TEXT: string;
  PICKUP_MODAL_SHIPPING_BUTTON_TEXT: string;
  ORDER_DETAILS_RETURN_STATUS_SUBTITLE: string;
  ORDER_DETAILS_EXCHANGE_STATUS_SUBTITLE: string;
  ORDER_DETAILS_STORE_CREDIT_STATUS_SUBTITLE: string;
  ORDER_DETAILS_LIST_TITLE_TEXT: string;
  ORDER_DETAILS_LIST_ITEM_TEXT: string;
  ADDRESS_PICKUP_UNAVAILABLE: string;
  HOW_YOU_WANT: string;
  PICK_BEST_METHOD: string;
  RETURN_OPTION_MODAL_TITLE: string;
  RETURN_OPTION_MODAL_SUBTEXT: string;
  SELECT_ITEMS_RETURN_HEADER: string;
  SELECT_ITEMS_RETURN_SUBHEADER: string;
  GREEN_RETURN_METHOD_TITLE: string;
  GREEN_RETURN_METHOD_TITLE_PLURAL: string;
  GREEN_RETURN_METHOD_SUBTITLE: string;
  GREEN_RETURN_METHOD_SUBTITLE_PLURAL: string;
  STANDARD_EXCHANGE_SUB_HEADER: string;
  INSTANT_EXCHANGE_SUB_TEXT: string;
  RETURN_DETAILS_HEADER: string;
  RETURN_DETAILS_SUB_HEADER: string;
  ITEM_DETAILS_RETURN_HEADER: string;
  ITEM_DETAILS_RETURN_SUB_HEADER: string;
  ITEM_DETAILS_ADD_BUTTON_TEXT: string;
  ITEM_DETAILS_EDIT_BUTTON_TEXT: string;
  SAME_ITEM_EXCHANGE_TITLE: string;
  SAME_ITEM_EXCHANGE_SUBTITLE: string;
  VARIANT_EXCHANGE_TITLE: string;
  VARIANT_EXCHANGE_SUBTITLE: string;
  EXCHANGE_GROUPS_TITLE: string;
  EXCHANGE_GROUPS_SUBTITLE: string;
  BACKORDER_HEADING: string;
  BACKORDER_SUBTITLE: string;
  ShipmentMethodName_PICKUP_TITLE: string;
  ShipmentMethodName_IN_STORE_TITLE: string;
  ShipmentMethodName_DROPOFF_TITLE: string;
  ShipmentMethodName_SELF_SHIP_TITLE: string;
  ShipmentMethodName_HAPPY_RETURNS_TITLE: string;
  ShipmentMethodName_BLUE_YONDER_TITLE: string;
  ShipmentMethodName_RETURN_BEAR_TITLE: string;
  ShipmentMethodName_SETTLEMENT_TITLE: string;
  ShipmentMethodName_MANUAL_LABEL_TITLE: string;
  ShipmentMethodName_PICKUP_SUBTEXT: string;
  ShipmentMethodName_IN_STORE_SUBTEXT: string;
  ShipmentMethodName_DROPOFF_SUBTEXT: string;
  ShipmentMethodName_SELF_SHIP_SUBTEXT: string;
  ShipmentMethodName_HAPPY_RETURNS_SUBTEXT: string;
  ShipmentMethodName_BLUE_YONDER_SUBTEXT: string;
  ShipmentMethodName_RETURN_BEAR_SUBTEXT: string;
  ShipmentMethodName_SETTLEMENT_SUBTEXT: string;
  ShipmentMethodName_MANUAL_LABEL_SUBTEXT: string;
  ShipmentMethodName_BLUE_YONDER_LOCATIONS_TEXT: string;
}

export type VariantResource<K extends string> = Resource & {
  variants?: { [key in K]?: Partial<Resource> };
};

type ReturnMethod = "exchange";

export type Variants =
  | ReturnType
  | ReturnMethod
  | "return_claim"
  | "pickup"
  | "repair"
  | "third-party"
  | "recycle";

type LanguageResourceImport = typeof languageResource;

// If the imported object is not a VariantResource, than we exclude it from the LanguageResource type
type LanguageResource = {
  [K in keyof LanguageResourceImport as LanguageResourceImport[K] extends VariantResource<Variants>
    ? K
    : never]: LanguageResourceImport[K];
};

type LanguageRegions = keyof LanguageResource;

export type LanguageResourceOverride = {
  [key in LanguageRegions]?: Partial<VariantResource<Variants>>;
};

export const getLanguageRegion = ({
  languageCode,
  countryCode,
}: {
  languageCode?: string;
  countryCode: string;
}): LanguageRegions => {
  const languageRegion =
    `${languageCode || "EN"}_${countryCode}`.toUpperCase() as LanguageRegions;
  return languageRegion in languageResource ? languageRegion : "COMMON";
};

export const getResource = ({
  language,
  variant,
  overrides,
}: {
  language?: LanguageRegions;
  variant?: Variants;
  overrides?: LanguageResourceOverride;
}): Resource => {
  let resource = languageResource.COMMON;
  if (language) {
    resource = { ...resource, ...languageResource[language] };
  }

  if (variant) {
    resource = { ...resource, ...resource.variants?.[variant] };
  }

  if (overrides) {
    let override = language ? overrides[language] : overrides.COMMON;
    if (variant && override?.variants) {
      override = { ...override, ...override?.variants?.[variant] };
    }
    resource = { ...resource, ...override };
  }

  return resource;
};
